import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';
import type { Crumb } from '../ui/Breadcrumb';

const Ctx = createContext<{ crumbs: Crumb[]; setCrumbs: (c: Crumb[]) => void }>({
  crumbs: [],
  setCrumbs: () => undefined,
});

export function CrumbProvider({ children }: { children: ReactNode }) {
  const [crumbs, setCrumbs] = useState<Crumb[]>([]);
  return <Ctx.Provider value={{ crumbs, setCrumbs }}>{children}</Ctx.Provider>;
}

/** Pages publish their breadcrumb trail to the top bar. */
export function useCrumbs(crumbs: Crumb[]) {
  const { setCrumbs } = useContext(Ctx);
  const key = JSON.stringify(crumbs);
  useEffect(() => {
    setCrumbs(JSON.parse(key) as Crumb[]);
  }, [key, setCrumbs]);
}

export const useCurrentCrumbs = () => useContext(Ctx).crumbs;
